import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiService} from '../api';

import {ContractAlert} from './contract-alerts.model';


@Injectable({
  providedIn: 'root'
})
export class ContractAlertsService {

  constructor(private api: ApiService) {
  }

  public getAlerts(contractId: number): Observable<ContractAlert[]> {
    return this.api.ga20
      .get(`/contract/${contractId}/alerts`);
  }
}
